"use strict";
angular.module('showTenantInfoModule', [])
    .controller("showTenantInfoCtrl", ['$scope', '$filter', '$modalInstance', 'item', function($scope, $filter, $modalInstance, item) {
        initData();
        initStatus();
        /** [initData description]初始化数据 */
        function initData() {
            console.log(item);
        }
        /** [initStatus description] 初始化状态*/
        function initStatus() {
            $scope.data = item;
            $scope.address = item.PROVINCE + item.CITY + item.COUNTY + item.ADDRESS;
            $scope.data.CRTIME = $scope.data.CRTIME.substring(0, 10);
            handleTime();
        }
        /** [cancel description]关闭弹窗 */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        /**
         * [handleTime description] 处理时间格式
         * @return {[type]} [description]
         */
        function handleTime() {
            $scope.data.STARTTIME = $filter("date")(new Date(Date.parse($scope.data.STARTTIME)), "yyyy-MM-dd");
            $scope.data.ENDTIME = $filter("date")(new Date(Date.parse($scope.data.ENDTIME)), "yyyy-MM-dd");
        }
    }]);